function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_9681",
  "data-name": "Group 9681",
  transform: "translate(4023 -10232)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_5324",
  "data-name": "Rectangle 5324",
  transform: "translate(-4023 10232)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 23.903,
  height: 28.5,
  rx: 4,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 21.903,
  height: 26.5,
  rx: 3,
  fill: "none"
})), /*#__PURE__*/React.createElement("line", {
  id: "Line_1436",
  "data-name": "Line 1436",
  x2: 13.79,
  transform: "translate(-4017.944 10239.814)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_1437",
  "data-name": "Line 1437",
  x2: 13.79,
  transform: "translate(-4017.944 10246.25)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_1438",
  "data-name": "Line 1438",
  x2: 13.79,
  transform: "translate(-4017.944 10252.686)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_9680",
  "data-name": "Group 9680",
  transform: "translate(-3993.639 10242.782) rotate(48)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Polygon_1",
  "data-name": "Polygon 1",
  d: "M1.5,0,3,1.286H0Z",
  transform: "translate(3 14.148) rotate(180)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3854",
  "data-name": "Rectangle 3854",
  width: 3,
  height: 10.933,
  transform: "translate(0 1.608)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3855",
  "data-name": "Rectangle 3855",
  width: 3,
  height: 1.286,
  transform: "translate(0)",
  fill: "#fff"
})));

function SvgIa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.369,
    height: 28.5,
    viewBox: "0 0 31.369 28.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIa);
export default __webpack_public_path__ + "static/media/IA.6ca74c03.svg";
export { ForwardRef as ReactComponent };